import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import aside from './img/logo.png'
import aside2 from './img/dgo-logo.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'nubenet';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage");

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-nubenet-container" ref={nodeRef}>
        <Form className="login-form" onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="nubenet-form-container">
            <h1 className="desc">{translate("ClientAuthentication")}</h1>
            <div className="nubenet-separator"></div>
            <Row className="nubenet-form-body">
              <Col sm="12" xs="12" md="12" className="nubenet-input">
                <div><p className="detail">{translate("PlaceholderUserName")}</p></div>
                <Input
                  className="user-input-nubenet"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                  placeholder=""
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="nubenet-input">
                <div><p className="detail">{translate("PlaceholderPassword")}</p></div>
                <Input
                  className="pass-input-nubenet"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder=""
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
              <div className="changePassword">
                <a href="https://dgonubenet.ispcube.com/dgo/recoverpassword?company=251" className="changePassword">{translate("ForgotPassword")}</a>
              </div>
              <Col sm="12" xs="12" md="12" className="nubenet-input">
                {!onLogin ? (
                  <button
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-nubenet"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </Col>

            </Row>
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
          </Container>
        </Form>
        <div className="asda">
          <div className="logo-costad-div"><img src={aside} alt="aside" className="logo-costado" />
            <img alt="aside2" className="logo-costado2" src={aside2} /></div>
        </div>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
